define(function(require) {
    const ActionsTemplate = require('./Actions.template.html');
    const BaseView = require('app/Base.view');
    const $ = require('jquery');
    const _ = require('underscore');
    const Backbone = require('backbone');
    const CC = require('CC');

    const actionsView = BaseView.extend({
        defaults: {
            data: [
                {
                    newTab: false
                }
                // Example Action
                // {
                //   icon: 'lotacon lotacon-stats',
                //   ccEventName: 'DataPayouts:edit',
                //   isEnabled: function() { return true; }
                //   isVisible: function() { return true; }
                //   url: function() { return  'audience/stats/audience_id/this.model.get(id)'; } OR 'http://www.lotame.com'
                //   newTab: boolean, if true and url, opens link in new tab
                //   title: The tooltip Or name item when in the "More" dropdown
                //   disabledTitle: The tooltip when disabled
                //   isUnderMore: boolean, if true it goes under the "more" options,
                //   eventFn: function(model, isEnabled, event) {}
                //   class: String|function for the icon
                //   rowClass: String|function for the row
                // }
            ],
            model: new Backbone.Model()
        },

        template: _.template(ActionsTemplate),

        initialize: function(options) {
            _.extend(this, this.defaults, options);

            return this;
        },

        prepareItems: function() {
            const annotatedItems = _.map(_.result(this, 'data'), item => {
                // Add the model for context
                item.model = this.model;

                // Create a new object with the original item's properties
                const annotated = { ...item };

                // Compute new properties with different names to avoid overwriting
                annotated.isEnabled = CC.utils.getResult(item, 'isEnabled', true, this.model);
                annotated.isEnabledClass = annotated.isEnabled ? '' : 'disabled';

                annotated.url = annotated.isEnabled && CC.utils.getResult(item, 'url', false, this.model);
                annotated.isLink = annotated.isEnabled && annotated.url;
                annotated.newTab = CC.utils.getResult(item, 'newTab', false, this.model);

                annotated.buttonText = CC.utils.getResult(item, 'buttonText', '', this.model);
                annotated.customClass = CC.utils.getResult(item, 'class', '', this.model);
                annotated.iconClass = CC.utils.getResult(item, 'icon', '', this.model);

                annotated.title = CC.utils.getResult(item, 'title', '', this.model);
                annotated.disabledTitle = CC.utils.getResult(item, 'disabledTitle', '', this.model);
                annotated.tooltip = annotated.isEnabled ? annotated.title : annotated.disabledTitle;

                annotated.rowClass = CC.utils.getResult(item, 'rowClass', '', this.model);

                // Handle icon class special case
                if (annotated.iconClass && annotated.iconClass.indexOf('lotacon') === -1) {
                    annotated.iconClass = `icon ${annotated.icon}`;
                }

                // Set default disabled title if not provided
                if (_.isEmpty(annotated.disabledTitle)) {
                    annotated.disabledTitle = 'This action is currently disabled';
                }

                annotated.isUnderMore = CC.utils.getResult(item, 'isUnderMore', false);

                // Generate action identifier
                const identifier = item.ccEventName || annotated.title || 'action';
                annotated.actionId = identifier.replace(/\s/g, '') || _.uniqueId('action-');

                return annotated;
            });
            return _.filter(annotatedItems, item => {
                if (_.isFunction(item.isVisible)) {
                    return item.isVisible(this.model);
                }
                return item.isVisible === undefined || item.isVisible;
            });
        },

        events: {
            'click .icon-action-link': 'handleClick',
            'click .btn': 'handleClick'
        },

        render: function() {
            const self = this;
            const $el = $(this.el);
            this.visibleItems = this.prepareItems();

            const preparedItems = {
                displayed: _.where(self.visibleItems, { isUnderMore: false }),
                more: _.where(self.visibleItems, { isUnderMore: true })
            };
            $el.empty().append(
                self.template({
                    model: this.model,
                    items: preparedItems
                })
            );
            if (!_.isUndefined(this.$el)) {
                self.$('[data-toggle="tooltip"]').tooltip({
                    container: 'body'
                });
            }
            return self;
        },

        disable: function(reason) {
            this.disableElement('.actions-list-action');
            this.disableElement('.actions-list-action i');
            if (reason) {
                this.$('.actions-list-action i').prop('title', reason);
            }
        },

        handleClick: function(evt) {
            const targetData =
                this.$(evt.target)
                    .closest('.icon-action-link')
                    .data() ||
                this.$(evt.target)
                    .closest('.button-action-link')
                    .data();
            if (!targetData) return;

            const item = this.visibleItems.find(item => item.actionId === targetData.actionId);
            if (!item) return;
            if (!item.url) {
                const $btn = $(evt.currentTarget).parent();
                let shouldWait = false;

                const isEnabled = item.isEnabled;
                if (isEnabled) {
                    if (!_.isUndefined(item.ccEventName)) {
                        CC.Events.trigger(item.ccEventName, this.model);
                    }
                    if (_.isFunction(item.eventFn)) {
                        $btn.addClass('action-loader');
                        $btn.prop('disabled', true);

                        try {
                            const xhr = item.eventFn.apply(this, [this.model, isEnabled, evt]);

                            if (xhr && _.isFunction(xhr.always)) {
                                shouldWait = true;
                                xhr.always(() => {
                                    this.render();
                                });
                            }
                        } finally {
                            if (!shouldWait) {
                                this.render();
                            }
                        }
                    }
                }
            }
        }
    });
    return actionsView;
});
